let mutations = {
    setLexamStatus(state, data) {
        // 变更L1-3低级问答播放audio播放状态
        state.lexam_status = data;
    },
    setMexamStatus(state, data) {
        // 变更L1-3低级问答播放audio播放状态
        state.mexam_status = data;
    }
}
export default mutations;


// WEBPACK FOOTER //
// ./src/vuex/modules/audioStatus/mutations.js